import { ReactNode } from 'react';

const LayoutDashboard = ({ children }: { children: ReactNode }) => (
    <div className="layout-dashboard screen screen__login">
        {children}
    </div>
);

export default LayoutDashboard;
